var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [_c("customer-info")], 1),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _vm.depositId && _vm.depositId > 0
            ? _c("chat-box", {
                attrs: { orderId: _vm.depositId, orderType: 2 }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("bill-of-lading", {
            attrs: { depositId: _vm.depositId, needLoad: _vm.needLoad }
          })
        ],
        1
      )
    ]),
    _vm.deposit.status !== 7 &&
    _vm.deposit.status !== 9 &&
    _vm.deposit.status !== 10
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("new-transaction-code", {
                on: {
                  eventAddTranCode: function($event) {
                    return _vm.onAddTranCode($event)
                  }
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [_c("amount-detail-deposit", { attrs: { deposit: _vm.deposit } })],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("change-hist", {
            attrs: { historiesChanged: _vm.deposit.changedHistories }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("payment-hist", {
            attrs: { paymentHistory: _vm.deposit.paymentHistory }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [_c("deposit-detail-footer", { attrs: { deposit: _vm.deposit } })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }